<form class="import-users" [formGroup]="form">
  <div class="import-users__title">{{ 'components.importUsers.labels.title' | translate }}</div>

  <div class="import-users__link">
    <app-download-link [fileLink]="'assets/docs/Шаблон для импорта пользователей.xlsx'">
      {{ 'components.importUsers.buttons.downloadTemplate' | translate }}
    </app-download-link>
  </div>

  <div class="import-users__form">
    <app-input-files
      tabindex="1"
      formControlName="file"
      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
      [tuiTextfieldSize]="tuiElementSize"
      [loading]="loading"
    ></app-input-files>
  </div>

  <div class="import__buttons" [class.tui-skeleton]="loading" [class.tui-skeleton_text]="loading">
    <button tuiButton type="button" [size]="tuiElementSize" (click)="onClickSaveButton()">
      {{ 'components.importUsers.buttons.upload' | translate }}
    </button>
  </div>
</form>
